import { BLOCK_TYPES } from "../../common";
import { renderEditorCrossword } from "../Crossword";

const { INPUT_EXPAND_NUMBER_BLOCK } = BLOCK_TYPES;

const renderEditor = (props: any) =>
    renderEditorCrossword({
        ...props,
        blockType: INPUT_EXPAND_NUMBER_BLOCK,
        // showFeedback: true,
    });

export default renderEditor;
